import { configureStore } from "@reduxjs/toolkit";
import addBookSlice from "./slices/books/addBookSlice";
import bookSelectionSlice from './slices/books/bookSelectionSlice';
import authSlice from "./slices/auth/authenticationSlice";
import usersSlice from "./slices/users/usersSlice";
import featureSlice from "./slices/features/userFeatureSlice";


window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
export const store = configureStore({
    reducer: {
        auth:authSlice,
        addBooks:addBookSlice,
        bookSelection:bookSelectionSlice,
        users:usersSlice,
        features:featureSlice
    }
});